import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, Field, FieldProps, FormikProps } from 'formik';
import { FormControl, Input, FormHelperText, InputAdornment } from '@material-ui/core';

import { INetwork, IShare } from '../types';
import Count from './Count';

interface IFormValue {
  [name: string]: string;
}

interface IProps {
  network: INetwork;
}

interface IPropsEnhanced extends IProps {
  formik: FormikProps<IShare>;
}

const Commentary: FC<IPropsEnhanced> = ({ formik, network }) => {
  const { t } = useTranslation();
  const { values } = formik;
  const { provider } = network;

  const placeholder = `sharing:${network.provider}`;
  const item = values[provider];
  const { active } = item;

  if (!active) {
    return null;
  }

  return (
    <Field
      name={`${provider}.user_commentary`}
      render={(fieldProps: FieldProps<IFormValue>) => {
        const { errors, touched } = fieldProps.form;
        const { field } = fieldProps;

        const fieldValue = field.value || '';
        const hasError = !!(errors[name] && touched[name]);
        const nameError = touched[name] && errors[name];

        return (
          <FormControl fullWidth error={hasError} margin="dense">
            <Input
              multiline
              disableUnderline
              value={fieldValue}
              placeholder={t(placeholder)}
              onChange={field.onChange}
              inputProps={{ name: field.name }}
              endAdornment={
                <InputAdornment position="end">
                  <Count network={network} />
                </InputAdornment>
              }
            />
            {nameError && <FormHelperText>{nameError}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
};

export default connect<IProps>(Commentary);
